export default [
  ['Set up a Kubernetes cluster', true],
  ['Give a speech about programming', true, true],
  ['Join a team of highly-skilled and experienced people', true],
  ['Improve my spoken English', true],
  ['Sharpen my TypeScript skills', true],
  ['Contribute to an open source project', true],
  ['Write more tests and explore TDD approach', true],
  ['Increase presence on StackOverflow', true]
]
